<template>
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="8">
        <v-card class="ma-4 pa-2">
          <HelperCarregant v-if="loading" :missatge="t('Iniciando_la_sesión')" />
          <template v-if="!loading">
            <v-card-title>{{ t('Iniciar_sesión') }}</v-card-title>
            <v-card-text>
              <form @submit.prevent="login">
                <v-text-field v-model="email" prepend-icon="mdi-email" :label="t('Email')" type="email"
                  required></v-text-field>
                <v-text-field v-model="password" prepend-icon="mdi-lock" :label="t('Contraseña')" type="password"
                  required></v-text-field>
                <v-btn :loading="loading" block color="primary" type="submit">{{ t('Iniciar_sesión') }}</v-btn>
              </form>
              <v-divider class="my-4"></v-divider>
            </v-card-text>
            <v-row justify="center" align="center">
              <v-btn class="ma-2" size="x-small" @click="$router.push('/passreset')">{{ t('No_recuerdas_tu_c')
              }}</v-btn>
              <v-btn class="ma-2" size="x-small" @click="$router.push('/verifyresend')">{{
                t('No_has_recibido_el_email_de_verificacion') }}</v-btn>
            </v-row>
            <v-card-actions class="justify-center">
              <span>{{ t('No_tienes_cuenta') }}</span>
              <v-btn color="primary" @click="$router.push('/register')">{{ t('Regístrate') }}</v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { axios, setAuthToken } from '../axios';

/* componentes */
import HelperCarregant from './HelperCarregant.vue';

/* Pinia stores */
import { useUiStore }    from '@/stores/ui';
import { useUserStore }  from '@/stores/user';
import { useCursosStore } from '@/stores/cursos';

const uiStore     = useUiStore();
const userStore   = useUserStore();
const cursosStore = useCursosStore();

const { t }  = useI18n();
const router = useRouter();

/* ------------ estado local ------------ */
const email    = ref('');
const password = ref('');
const loading  = ref(false);

/* ------------ login ------------ */
async function login() {
  loading.value = true;
  try {
    const { data } = await axios.post('login/', { email: email.value, password: password.value });
    localStorage.setItem('authToken', data.key);
    setAuthToken(data.key);

    /* carga inicial */
    await Promise.all([
      userStore.fetchUserDetails(),
      userStore.fetchProfesionales(),
      cursosStore.fetchCursos(),
    ]);

    router.push('/');
  } catch (err) {
    let msg = '';
    if (err?.response?.data) {
      const d = err.response.data;
      msg = d.non_field_errors?.join(', ')
        || d.detail
        || JSON.stringify(d);
    } else {
      msg = String(err);
    }
    uiStore.triggerSnackbar({ message: msg, color: 'error' });
  } finally {
    loading.value = false;
  }
}
</script>